module.exports = __webpack_public_path__ + "static/media/hero-big.eed79b0d.jpg";